import isAnySessionChatId from '@medflex/utils/isAnySessionChatId';
import React from 'react';
import { USER_TYPES } from '@medflex/utils/constants';
import isStaffUserId from '@medflex/utils/isStaffUserId';
import formatDateOfBirth from '@medflex/utils/getDateOfBirthFormatted';
import format from 'date-fns/format';
import isSelf from './isSelf';
import isSupportPatient from './isSupportPatient';

export default (contact, userProfile, t) => {
  const { user, enabled, pairedAt, id, type, createdAt } = contact;
  const { attributes: userProfileAttributes } = userProfile;

  if (isSelf(user)) return t('global:utils.getSubtitle.team');

  if (isSupportPatient(user)) return t('global:utils.getSubtitle.support');

  // for some reason we have the attribute enabled for addressBookContacts and pairedAt for chatContacts
  if (
    user.organizationId &&
    userProfileAttributes.organization &&
    !((enabled || pairedAt) && user.workplace)
  ) {
    return userProfileAttributes.organization.name;
  }

  if (!isSupportPatient(user) && id && !pairedAt && !isAnySessionChatId(id))
    return t('global:utils.getSubtitle.invited', { date: format(createdAt, 'DD.MM.YYYY') });

  if (!isSupportPatient(user) && type === USER_TYPES.PATIENT) {
    return (user.dateOfBirth && formatDateOfBirth(user.dateOfBirth)) || '';
  }

  if (user && isStaffUserId(user.id)) {
    if (!user.activatedAt) {
      return t('global:utils.getSubtitle.invited', {
        date: format(user.createdAt, 'DD.MM.YYYY'),
      });
    }

    return <div className="font-semibold truncate">{userProfileAttributes.workplace}</div>;
  }

  return <div className="font-semibold truncate">{user.workplace || user.subtitle || ''}</div>;
};
